/**
 * post1 1b — 위성사진(브이월드 WMTS) 출처 표기 «단일 원천». 입출력 0 · vitest 잠금(src/__tests__/post1-vworld.test.ts).
 *
 *   공공누리 제1유형 「출처 표시 의무」 + 「온라인에서 하이퍼링크 제공이 가능하면 링크를 제공」(kogl.or.kr licenseType1)
 *   → 남는 위성 노출 지점 전부(갤러리·카드 title·duo 알약·허브 배너·JSON-LD creditText)가 이 문구 하나를 쓴다.
 *   종전 「위성사진 © VWorld」 는 권리자를 단정하고 링크가 없어 대체했다(report/cl/risk_audit1/satref_source ① c).
 *   ⛔ 이 문구를 다른 파일에 손으로 다시 쓰지 않는다 — 정적 검사가 «© VWorld» 잔존을 잡는다.
 *   글자 크기: 화면 표기는 12px 이상(VWORLD_ATTRIBUTION_MIN_PX · .ainote 12px · .kd-mf-chip 12px · .kd-mf-cap 13px).
 */

export const VWORLD_ORG = '국토교통부 공간정보 오픈플랫폼(브이월드)';
export const VWORLD_URL = 'https://www.vworld.kr';
/** 링크 앞 글자(화면에서 이 뒤에 VWORLD_URL 링크가 붙는다). */
export const VWORLD_ATTRIBUTION_LABEL = `출처: ${VWORLD_ORG}`;
/** 평문 한 줄(title·figcaption·이미지 알약·JSON-LD creditText). */
export const VWORLD_ATTRIBUTION = `${VWORLD_ATTRIBUTION_LABEL} ${VWORLD_URL}`;
export const VWORLD_ATTRIBUTION_MIN_PX = 12;

/** 문구에 단일 출처 표기(기관명 + 링크 주소)가 들어 있는가. */
export function hasVworldAttribution(s: string | null | undefined): boolean {
  const t = String(s ?? '');
  return t.includes(VWORLD_ORG) && t.includes(VWORLD_URL);
}

/** 캡션 뒤에 출처를 붙인다(이미 있으면 그대로). 캡션이 비면 출처만. */
export function withVworldAttribution(caption: string | null | undefined): string {
  const c = String(caption ?? '').trim();
  if (hasVworldAttribution(c)) return c;
  return c ? `${c} · ${VWORLD_ATTRIBUTION}` : VWORLD_ATTRIBUTION;
}
